(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const update = (hero) => {
    const endValue = hero.dataset.ends || '';
    const end = new Date(endValue).getTime();
    let seconds = Number.isFinite(end) ? Math.max(0, Math.floor((end - Date.now()) / 1000)) : 0;
    const days = Math.floor(seconds / 86400);
    seconds %= 86400;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const values = { days, hours, minutes, seconds: remainingSeconds };

    Object.entries(values).forEach(([unit, value]) => {
      const output = hero.querySelector(`[data-et-time="${unit}"]`);
      if (output) output.textContent = pad(value);
    });
  };

  const init = (hero) => {
    update(hero);
    window.setInterval(() => update(hero), 1000);

    const stage = hero.querySelector('.et-aktion-stage');
    const ribbon = hero.querySelector('.et-aktion-ribbon');
    if (!stage || !ribbon) return;

    const placeRibbon = () => {
      if (window.matchMedia('(max-width: 750px)').matches) {
        ribbon.style.visibility = 'visible';
        return;
      }
      const width = stage.clientWidth;
      const height = stage.clientHeight;
      if (width <= 0 || height <= 0) {
        ribbon.style.visibility = 'hidden';
        return;
      }

      const style = window.getComputedStyle(hero);
      const edgeTop = parseFloat(style.getPropertyValue('--et-ak-edge-top')) / 100;
      const edgeBottom = parseFloat(style.getPropertyValue('--et-ak-edge-bottom')) / 100;
      const xStart = width * edgeTop;
      const xEnd = width * edgeBottom;
      ribbon.style.width = `${Math.hypot(xEnd - xStart, height) + 60}px`;
      ribbon.style.left = `${xStart}px`;
      ribbon.style.top = '-24px';
      ribbon.style.transform = `rotate(${Math.atan2(height, xEnd - xStart)}rad)`;
      ribbon.style.visibility = 'visible';
    };

    placeRibbon();
    window.addEventListener('resize', placeRibbon, { passive: true });
    if ('ResizeObserver' in window) {
      hero._etAkRibbonObserver = new ResizeObserver(placeRibbon);
      hero._etAkRibbonObserver.observe(stage);
    }
  };

  document.querySelectorAll('[data-et-aktion-hero]').forEach(init);
})();
